import { fromJS } from 'immutable'
import * as ReducerActions from './actions'

const initialState = fromJS({
    loading: {
        show: false,
        message: ''
    },
    header: {
        show: true,
        showDrawer: true,
        showBackButton: false,
    },
    inicializandoUsuario: true,
    permiteUsuarioAnonimo: false,
})

export default function layoutReducer(state = initialState, action) {
    
    if(action.type === ReducerActions.SAVE_LOADING) {
        return state.set("loading", action.payload)
    }

    if(action.type === ReducerActions.SAVE_HEADER_SHOW){
        return state.setIn(["header", "show"], action.payload)
    }

    if(action.type === ReducerActions.SAVE_INICIALIZANDO_USUARIO){
        return state.set("inicializandoUsuario", action.payload)
    }

    if(action.type === ReducerActions.SAVE_PERMITE_USUARIO_ANONIMO){
        return state.set("permiteUsuarioAnonimo", action.payload)
    }

    return state
}